import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import i18n from 'i18n';
import { setAlert } from 'actions/alerts';
import { THREE_MB } from 'utils/file';
var imageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml'];
export var commonThumbnailOptions = {
  multiple: false,
  accept: imageTypes,
  maxSize: THREE_MB
};
export function handleRejectFiles(rejectedFiles) {
  if (rejectedFiles.length > 1) {
    setAlert({
      title: i18n.t('error_upload_only_single_file')
    });
  } else if (rejectedFiles[0].type && !imageTypes.includes(rejectedFiles[0].type)) {
    setAlert({
      title: i18n.t('error_file_type_unsupported_thumbnail')
    });
  } else if (rejectedFiles[0].size > THREE_MB) {
    setAlert({
      title: i18n.t('error_file_too_large')
    });
  } else {
    setAlert({
      title: "".concat(i18n.t('error_uploading_file'), " ").concat(rejectedFiles[0].name)
    });
  }
}